

document.addEventListener("DOMContentLoaded", () => {
	const hasFilter = document.querySelector('.filtr-controls');
	if (hasFilter) {
		// set default filter based on URL
		let defaultFilter = window.location.hash.substring(1);
		if (!defaultFilter || defaultFilter == 'filter') defaultFilter = 'all';
		document.getElementById('filtr-current').innerHTML = defaultFilter;

		//
		// FILTERIZR 
		//
		const options = {
			animationDuration: 0.5,
			callbacks: {
				onInit: function() {
					let current = document.getElementById('filtr-current').innerHTML;
					document.querySelector('[data-filter=' + current + ']').classList.add('active');
				},
				onFilteringStart: function(e) {
					const filters = document.querySelectorAll('[data-filter]');
					filters.forEach((f) => {
						f.classList.remove('active');
					}); 
					let current = document.getElementById('filtr-current').innerHTML;
					document.querySelector('[data-filter=' + current + ']').classList.add('active');
				},
				onFilteringEnd: function(e) { 
					let items = document.getElementsByClassName('filteredOut');
					for (let i = 0; i < items.length; i++)
					{
						items[i].style.display = 'none';
					}
				},
				onShufflingStart: function() { },
				onShufflingEnd: function() { },
				onSortingStart: function() { },
				onSortingEnd: function() { }
			},
			controlsSelector: '',
			gutterPixels: 0,
			easing: 'ease-out',
			filter: defaultFilter,
			filterOutCss: {
				opacity: 0,
				transform: 'scale(0.5)',
			},
			filterInCss: {
				opacity: 1,
				transform: 'scale(1)'
			},
			delay: 25,
			delayMode: 'alternate',
			layout: 'sameSize',
			spinner: {
				enabled: true,
				fillColor: '#ff4338',
				styles: {
					height: '75px',
					margin: '0 auto',
					width: '75px',
					'z-index': 2
				}
			}
		}
	
		const filterizr = new Filterizr('.filtr-container', options);
	}
});